import { useModal } from "../../../../utils/modal_launcher";
import { LogWeighingModal } from "../log_weighing_modal";

type Props = {
  lastWeighing: any;
  refetch: () => void;
};

function formatWeight(weightOz: number): string {
  const lbs = Math.floor(weightOz / 16);
  const oz = weightOz % 16;
  return oz === 0 ? `${lbs} lbs` : `${lbs} lbs ${oz} oz`;
}

function formatDate(dateStr: string): string {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString([], {
    month: "short",
    day: "numeric",
  });
}

export const WeighingWidget = ({ lastWeighing, refetch }: Props) => {
  const logWeighingModal = useModal(LogWeighingModal);

  return (
    <div className="col-12 col-md-6">
      <div className="card border-0 shadow bg-gray-3 my-4 dashboard-card">
        <div className="card-body text-center">
          <div className="fs-24 fw-bold text-muted text-uppercase">Weight</div>
          {lastWeighing?.weighed_on ? (
            <>
              <div className="fs-48 desktop-fs-60 fw-bold mt-2">
                {lastWeighing.weight_oz != null
                  ? formatWeight(lastWeighing.weight_oz)
                  : "—"}
              </div>
              <div className="d-flex align-items-center justify-content-center gap-2 fs-m-30 fs-40 gray-c fw-bold mt-3">
                <div>{formatDate(lastWeighing.weighed_on)}</div>
                <div className="w-0px">
                  <button
                    className="btn btn-text ml-4"
                    style={{ fontSize: "1.2rem", lineHeight: 1 }}
                    onClick={() =>
                      logWeighingModal.show({ weighing: lastWeighing, refetch })
                    }
                    aria-label="Edit weighing"
                  >
                    <i className="bi bi-pencil" />
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p className="text-muted mt-4">No entries logged yet</p>
          )}
          <div className="container mt-4">
            <button
              className="btn btn-primary fs-28 col-12 col-sm-4"
              onClick={() => logWeighingModal.show({ refetch, lastKnownWeightOz: lastWeighing?.weight_oz })}
            >
              Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
